<template>
<div id="allservices">

    <div class="want-price all-services clearfix">
        <div class="wrapper clearfix">
            <div class="col-md-120">
                <h2>Рассчитать стоимость ремонта за 10 минут</h2>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <select>
                            <option selected>Марка</option>
                            <option>Марка</option>
                            <option>Марка</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <select>
                            <option selected>Модель</option>
                            <option>Модель</option>
                            <option>Модель</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <select>
                            <option selected>Год выпуска</option>
                            <option>Год выпуска</option>
                            <option>Год выпуска</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <input type="text" placeholder="VIN-код">
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <select>
                            <option selected>Вид работ</option>
                            <option>Вид работ</option>
                            <option>Вид работ</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <select>
                            <option selected>Категория</option>
                            <option>Категория</option>
                            <option>Категория</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <select>
                            <option selected>Город</option>
                            <option>Город</option>
                            <option>Город</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <input type="text" placeholder="Район или улица">
                    </div>
                </div>
                <div class="col-xs-120">
                    <div class="field width-100">
                        <input type="text" class="width-100" placeholder="Опишите проблему">
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <input type="text" placeholder="Ваше имя">
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <input type="tel" name="phone_number" placeholder="">
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="field">
                        <input type="email" placeholder="Email">
                    </div>
                </div>
                <div class="col-lg-30 col-md-40 col-sm-60">
                    <div class="add-photo">
                        <router-link to="#" data-toggle="tooltip" title="Это текст подсказки">
                            <img src="/static/img/general/tooltip.png">
                        </router-link>
                        <span>Прикрепить файл</span>
                        <img src="/static/img/general/add-photo-plus.png">
                    </div>
                </div>
                <div class="col-xs-120">
                    <div class="time">
                        <span>Мне удобно посетить сервсис</span>
                        <input type="date">
                        <span>в</span>
                        <input type="time">
                    </div>
                    <div class="get-offer">
                        <router-link to="#">Получить лучшие предложение от сервисов!</router-link>
                    </div>
                    <div class="agree">
                        <input type="checkbox">
                        <span>Я соглашаюсь с <router-link to="/pol-zovatel-skoe-soglashenie/" target="_blank">условиями обработки персональных данных</router-link></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="category all-services clearfix">
        <div class="wrapper clearfix">
            <div class="col-xs-120 no-padding padding-left choose-category clearfix">
                <div class="col-lg-30 col-sm-60 no-padding">
                    <ul class="menu right right-1">
                        <li><router-link to="#" onclick="return false;" class="diagnosis">Диагностика</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="body-work">Кузовные работы</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="suspension">Подвеска</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="glass">Стёкла, фары</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="brake-system">Тормозная система</router-link></li>
                    </ul>
                </div>
                <div class="col-lg-30 col-sm-60 no-padding">
                    <ul class="menu right right-2">
                        <li><router-link to="#" onclick="return false;" class="electrician">Электрика</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="additional-equipment long">Дополнительное оборудование</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="oil long">Масло, жидкости, фильтры</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="care">Полировка, уход</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="technical-service long">Техническое обслуживание</router-link></li>
                    </ul>
                </div>
                <div class="col-lg-30 col-sm-60 no-padding">
                    <ul class="menu right right-3">
                        <li><router-link to="#" onclick="return false;" class="transmission">Трансмиссия</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="protective-foil">Защитные плёнки</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="wash">Мойка, химчистка</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="difficult-fix long">Сложный агрегатный ремонт</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="tinted">Тонировка</router-link></li>
                    </ul>
                </div>
                <div class="col-lg-30 col-sm-60 no-padding">
                    <ul class="menu right right-4">
                        <li><router-link to="#" onclick="return false;" class="tire-service">Шиномонтаж</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="departure">Услуги с выездом</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="auto-lawyer">Автоюрист</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="replacement-battery">Замена АКБ</router-link></li>
                        <li><router-link to="#" onclick="return false;" class="buy-tire">Покупка резины</router-link></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="car-services clearfix">
        <div class="wrapper clearfix">
            <div class="col-md-60 no-padding">
                <div class="info clearfix">
                    <img src="/static/img/general/photo-service.png">
                    <div class="stars">
                        <span class="count">5</span>
                        <input class="stars star-4" id="star-4" type="radio" name="reviewStars"/>
                        <label title="gorgeous" for="star-4"></label>

                        <input class="stars star-3" id="star-3" type="radio" name="reviewStars"/>
                        <label title="good" for="star-3"></label>

                        <input class="stars star-2" id="star-2" type="radio" name="reviewStars"/>
                        <label title="regular" for="star-2"></label>

                        <input class="stars star-1" id="star-1" type="radio" name="reviewStars"/>
                        <label title="poor" for="star-1"></label>

                        <input class="stars star-0" id="star-0" type="radio" name="reviewStars"/>
                        <label title="bad" for="star-0"></label>
                    </div>
                    <div class="views">
                        <img src="/static/img/general/views.png">
                        <span>Отзывы: 26</span>
                    </div>
                    <div class="name">Коленвал Моторз</div>
                    <div class="address">ул. Новохохловская, д. 36</div><br>
                    <router-link to="#" onclick="return false;" class="sign-up">Записаться</router-link>
                </div>
            </div>
            <div class="col-md-60 no-padding">
                <div class="text-view">
                    <div class="block">
                        <router-link to="#" class="arrow-left">
                            <img src="/static/img/general/arrow-left.png">
                        </router-link>
                        <div class="comment">
                            <div class="name">Владими Супрун</div>
                            <span class="value">(оценка: 5)</span>
                            <div class="auto">ЗАЗ 968</div>
                            <div class="text">Отличный сервис, парни вмиг поставили на колёса моего зепера (ещё мой дед на нём летал). Перебрали карбюратор, отполировали кузов, прошлись по электрике, теперь и я летаю. Супер!</div>
                        </div>
                        <router-link to="#" class="arrow-right">
                            <img src="/static/img/general/arrow-right.png">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
  name: 'AllServices'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AllServices.vue